import React, { FC, useEffect, useMemo } from "react";
import { DrawerComponent, IFrameComponent } from "components";
import { MAIN_SITE } from "../../../constants";
import { getToken } from "utils";
import { usePermissionsState } from "context";

const UserEmbedded: FC<{
  isOpen: boolean;
  onClose: () => void;
  contactId: string;
  teamId: number;
  handle: string;
}> = ({ isOpen, onClose, contactId, teamId, handle }) => {
  const { permission } = usePermissionsState();

  const link = useMemo(() => {
    const getItemLinkParams = new URLSearchParams({
      token: String(getToken().accessToken),
      refreshToken: String(getToken().refreshToken),
      isBusinessProfile: "true",
      teamId: String(teamId),
      redirectTo: `/${handle}`,
      role: permission?.role || "",
    }).toString();

    return `${MAIN_SITE}/o/auth/login-with-token?${getItemLinkParams}`;
  }, [contactId, teamId, permission?.role, handle]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.data.close) {
        onClose();
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, []);

  return (
    <DrawerComponent isOpen={isOpen} onClose={onClose}>
      <IFrameComponent srcLink={link} height="100%" width="100%" />
    </DrawerComponent>
  );
};

export default UserEmbedded;
